// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"661":"66773329","719":"b4ec672e"}[chunkId] + ".chunk.js";
};